<template>
  <div class="">
    <formulaire />
    <contact />
  </div>
</template>

<script>
import formulaire from "@/views/myComponent/formulaire";
import contact from "@/views/myComponent/contact";

export default {
  name: "team",
  components: {
    contact,
    formulaire,
  },
  data: function() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
